module.exports = __webpack_public_path__ + "img/products-motorhome.8e286e07.jpeg";